import { useCallback, useState } from 'react';
import axios from 'axios';
import { DocumentType } from '../types/Types';

export const useAllDocumentTypes = (baseUrl: string) => {
  const [allDocumentTypes, setAllDocumentTypes] = useState<DocumentType[]>([]);
  const [allDocumentTypesLoaded, setAllDocumentTypesLoaded] = useState(false);

  const refreshAllDocumentTypes = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Authentication token missing');

      const response = await axios.get<DocumentType[]>(baseUrl, {
        headers: { 'x-auth-token': token },
      });
      setAllDocumentTypes(response.data);
    } catch {
      // Keep the last complete codebook while the filtered document list remains usable.
    } finally {
      setAllDocumentTypesLoaded(true);
    }
  }, [baseUrl]);

  return {
    allDocumentTypes,
    allDocumentTypesLoaded,
    refreshAllDocumentTypes,
    setAllDocumentTypes,
    setAllDocumentTypesLoaded,
  };
};
